import { render, staticRenderFns } from "./KubernetesElement.vue?vue&type=template&id=3d4b262a&scoped=true&"
import script from "./KubernetesElement.vue?vue&type=script&lang=js&"
export * from "./KubernetesElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4b262a",
  null
  
)

export default component.exports